import SessionIndexComponent from './session-index-component'

export default SessionIndexComponent
